module.exports = __webpack_public_path__ + "img/cumt-agh-hsp.b3b8ea62.jpg";